export enum CzechSalaryTaxAdjustmentType {
  DoplatekNaMinimalniOdvodZdravotnihoPojisteni = "DoplatekNaMinimalniOdvodZdravotnihoPojisteni",
  SlevaNaPoplatnika = "SlevaNaPoplatnika",
  SlevaNaStudenta = "SlevaNaStudenta",
  SlevaProInvalidniDuchodce = "SlevaProInvalidniDuchodce",
  SlevaProZTPP = "SlevaProZTPP",
}
